import PropTypes from 'prop-types';

export default {
  classes: PropTypes.object,
  selectedPassenger: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  handleClose: PropTypes.func,
  centered: PropTypes.bool,
  showDate: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  toggleRoutes: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/containers/seats/desktop/SeatSelectionDesktopContainerProps.js